import device from "src/styles/device";
import styled from "styled-components";

const Cotainer = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 24px;
  margin-bottom: 16px;

  :last-child {
    margin-bottom: 0;
  }

  @media ${device.laptop} {
    padding: 16px;
  }
`;

const Panel = ({ children }) => {
  return <Cotainer>{children}</Cotainer>;
};

export default Panel;
